import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: object = {
  response: null,
  isDeletedLaborHours: false,
  loading: false,
};

export const deleteLaborHoursReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.DELETE_LABOR_HOURS_SUCCESS: {
      return {
        ...state,
        isDeletedLaborHours: true,
        response: action.payload,
        loading: false,
      };
    }

    case laborHoursConstant.DELETE_LABOR_HOURS_FAILURE:
      return {
        ...state,
        isDeletedLaborHours: false,
        response: action.payload,
        loading: false,
      };

    case laborHoursConstant.DELETE_LABOR_HOURS_LOADER:
      return {
        ...state,
        loading: true,
      };

    case laborHoursConstant.DELETE_LABOR_HOURS_RESET:
      return intitialstate;

    default:
      return state;
  }
};
